import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { $countryStore } from '@lib/store';
import { type RecipientResponse, TransferRecipientTypeEnum } from '@shared/api/rest/recipients';
import { Table, TableCellType } from '@shared/widgets';

interface ITableProps {
  data: RecipientResponse[];
  isLoading?: boolean;
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
  setSelectedItemId: (data: string) => void;
}

export const RecipientsTable = (props: ITableProps) => {
  const countryStore = useUnit($countryStore.store);

  useEffect(() => {
    $countryStore.events.update();
  }, []);

  const getCountry = (code: string) => countryStore.data.find((c) => c.twoLetterCode === code)?.name || '';

  return (
    <Table
      columns={['Name', 'Type of Recipient', 'Account/IBAN number', 'Country', 'Currency']}
      items={props.data.map((row) => {
        return [
          {
            type: TableCellType.Text,
            value: row.type === TransferRecipientTypeEnum.Business ? row.companyName : `${row.firstName || ''} ${row.lastName || '-'}`,
          },
          {
            type: TableCellType.Text,
            value: row.type,
          },
          {
            type: TableCellType.Text,
            value: row.iban || row.accountNumber || '-',
          },
          {
            type: TableCellType.Text,
            value: getCountry(row.countryCode),
          },
          {
            type: TableCellType.Text,
            value: row.currency,
          },
        ];
      })}
      onClick={(rowIndex) => props.setSelectedItemId(props.data[rowIndex].id)}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
      isScrollable
      isLoading={props.isLoading}
    />
  );
};
